module.exports = __webpack_public_path__ + "static/media/xmas-set-2022-1.cd49f109.gif";